/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Nda_Uploaded_RowInputs */



/**
* | output |
* | --- |
* | "Paper scan uploaded on {date}" |
*
* @param {Nda_Uploaded_RowInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_uploaded_row = /** @type {((inputs: Nda_Uploaded_RowInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Uploaded_RowInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Scan papier téléversé le ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Escaneo en papel subido el ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Digitalização em papel enviada em ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Scansione cartacea caricata il ${i?.date}`)
	return /** @type {LocalizedString} */ (`Paper scan uploaded on ${i?.date}`)
});